<template lang="pug">
  #states.text-xs-center
    v-card
      v-list.panel
        v-list-group(
          v-for="state in filteredStates"
          :key="state"
          sub-group
          no-action
        )
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title 
                span.main-color-text.bold {{ state ? state : "No disponible" }}
                | - {{stateReports(state).length}} Asesoría{{stateReports(state).length > 1 ? 's': ''}}

          v-list-tile(v-for="(report, i) in stateReports(state)" :key="report.folio")
            v-list-tile-content(@click="openPopUp(report.folio)")
              v-list-tile-title.report {{i + 1}}. {{report.victimData.disappearanceMun}}, {{formatDate(report.victimData.disappearanceDate)}}

       

</template>

<script>
import moment from "moment";

export default {
  name: "States",
  props: {},
  computed: {
    reports: {
      get() {
        return this.$store.state.filteredReports;
      }
    },
    filteredStates: {
      get() {
        return this.$store.state.filteredStates;
      },
      set(value) {
        this.$store.commit("setFilteredStates", value);
      }
    }
  },
  methods: {
    stateReports(state) {
      return this.reports.filter(el => {
          return el.victimData.disappearanceState == state;
        })
        .sort((a, b) => {
          return (
            a.year - b.year
          );
        });
    },
    openPopUp(folio) {
      this.$store.commit("setSelection", folio);
    },
     formatDate(value) { 
      return value ? moment(value.month).locale('es').format("MMMM") + ' ' + value.year : "";
    }
  }
};
</script>

<style lang="scss">
#states .panel {
  height: 600px;
  overflow: scroll;
  border: 15px solid #eaeaea;
  padding: 0px;
  background-color: #f7f7f7;
}

.report {
  cursor: pointer;
}

.v-expansion-panel__header {
  padding: 0px 24px;
}

.v-list__group__header--sub-group .v-list__group__header__prepend-icon {
  padding: 0 0 0 1rem;
  margin: 0;
}

.theme--light.v-expansion-panel .v-expansion-panel__container {
  background-color: #f7f7f7;
}

.v-list__group__header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #acacac;
  height: 40px;
}

.v-list__group__header:hover {
  background-color: rgba(117, 44, 125, 0.43) !important;
}

.v-list__tile__title {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  color: #747474 !important;
  font-size: 12px;
}

.v-list__group__items--no-action .v-list__tile {
  background-color: #f7f7f7;
  padding-left: 30px;
  border-bottom: 1px solid #acacac;
  height: 40px;
}

.v-list__group__items--no-action .v-list__tile:hover {
  background-color: rgba(215, 219, 235, 0.43);
}
</style>
